import type { Currency } from "@anaconda/core/price/types"
import {
  Select,
  SelectTrigger,
  SelectValue,
} from "@rarible_int/anaconda_ui_components"

interface Props {
  currency: Currency
}

export function CurrencyFilter({ currency }: Props) {
  return (
    <Select disabled>
      <SelectTrigger className="uppercase">
        <SelectValue placeholder={currency.abbreviation} />
      </SelectTrigger>
    </Select>
  )
}
